import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';

import { ButtonBar } from 'C4';

import logo from 'assets/images/logo/logo.png';

const HeaderSub = ({ history, location }) => {
  const { pathname } = location;

  let path = '/main';
  if (pathname && pathname.match(/\/(.*?)\/(.*?)\//g)) {
    const [returnPath] = pathname.match(/\/(.*?)\/(.*?)\//g);
    path = returnPath.substring(0, returnPath.length - 1);
  }
  return (
    <div className="header header-back">
      <nav>
        <ul>
          <div className="item__wrapper">
            <button className="back" onClick={() => history.push(path)}>
              <span>
                <FontAwesomeIcon icon={['fas', 'chevron-left']} />
                <span>Back</span>
              </span>
            </button>
          </div>
          <div className="item__wrapper">
            <img src={`/${logo}`} className="logo" alt="logo" />
          </div>
          <div className="item__wrapper" />
        </ul>
      </nav>
    </div>
  );
};

export default withRouter(HeaderSub);

HeaderSub.propTypes = {
  location: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
};
